import { getMetaValueRaw } from '@rad/utility/meta';
import { getBaseURL } from './routes/_';
// A tour's links live on the root host. The permanent one, /tours/<id>, works for as long as the
// tour exists, which is why QR codes carry it; the custom one, /tours/<name>, works while the tour
// holds that name, which is why people share it. The server checks names; these shape them as typed.
export const VANITY_NAME_MAX = 60;
const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isGuid = (text) => GUID.test(text);
// A title or anything typed, as a name: "Third Annual Candlelight Tour" is third-annual-candlelight-tour,
// "St. Mary's & Main" is st-marys-and-main.
export const formatVanityName = (text) => text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, VANITY_NAME_MAX)
    .replace(/-+$/, '');
export const permanentTourUrl = (id) => `${getBaseURL()}/tours/${id}`;
export const customTourUrl = (name) => `${getBaseURL()}/tours/${name}`;
export const qrTourUrl = (id) => `${permanentTourUrl(id)}?src=qr`;
// What to hand someone who wants to share the tour: its name when it has one, never its id when it does.
export const tourShareUrl = (tour) => tour.vanityName === null ? permanentTourUrl(tour.id) : customTourUrl(tour.vanityName);
// A tour shown at its custom link is routed by that name; the server says which tour it found.
export const resolveTourId = (routeId) => { var _a; return isGuid(routeId) ? routeId : (_a = getMetaValueRaw('76U-TOUR-ID')) !== null && _a !== void 0 ? _a : routeId; };
// What the custom-link box keeps of what is typed: the name's shape, with a trailing hyphen allowed
// while the next word is still coming. The save trims it.
export const maskVanityInput = (text) => text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+/, '')
    .slice(0, VANITY_NAME_MAX);
export const trimVanityName = (text) => text.replace(/^-+|-+$/g, '');
